"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRestData = exports.process_success = exports.process_failure = exports.DataActionType = void 0;
var $ = require("jquery");
var urls_1 = require("../urls");
var utils_1 = require("../utils");
var DataActionType;
(function (DataActionType) {
    DataActionType["CREATE_PRE"] = "CREATE_PRE";
    DataActionType["READ_PRE"] = "READ_PRE";
    DataActionType["UPDATE_PRE"] = "UPDATE_PRE";
    DataActionType["BULK_UPDATE_PRE"] = "BULK_UPDATE_PRE";
    DataActionType["DELETE_PRE"] = "DELETE_PRE";
    DataActionType["LIST_PRE"] = "LIST_PRE";
    DataActionType["CREATE_POST"] = "CREATE_POST";
    DataActionType["READ_POST"] = "READ_POST";
    DataActionType["UPDATE_POST"] = "UPDATE_POST";
    DataActionType["BULK_UPDATE_POST"] = "BULK_UPDATE_POST";
    DataActionType["DELETE_POST"] = "DELETE_POST";
    DataActionType["LIST_POST"] = "LIST_POST";
})(DataActionType = exports.DataActionType || (exports.DataActionType = {}));
function get_settings(operation, data) {
    var http_type = "";
    switch (operation) {
        case DataActionType.CREATE_PRE:
            http_type = "POST";
            break;
        case DataActionType.READ_PRE:
            http_type = "GET";
            break;
        case DataActionType.UPDATE_PRE:
        case DataActionType.BULK_UPDATE_PRE:
            http_type = "PUT";
            break;
        case DataActionType.DELETE_PRE:
            http_type = "DELETE";
            break;
        case DataActionType.LIST_PRE:
            http_type = "GET";
            break;
    }
    return {
        type: http_type,
        contentType: "application/json",
        data: data,
    };
}
function process_failure(action_type, xhr, textStatus, errorThrown) {
    if (xhr.responseJSON) {
        var messages = (0, utils_1.process_drf_errors)(xhr.responseJSON);
        messages.forEach(function (message) {
            notification(message, { type: "error" });
        });
    }
    else
        notification("" + xhr, { type: "error" });
}
exports.process_failure = process_failure;
function process_success(action_type, data, textStatus, jqXHR) {
    if (action_type == DataActionType.UPDATE_POST ||
        action_type == DataActionType.CREATE_POST ||
        action_type == DataActionType.BULK_UPDATE_POST) {
        notification(gettext("Information successfully saved"));
    }
}
exports.process_success = process_success;
function useRestData(base_url, dispatch, success, fail) {
    function make_request(url, settings, action_type, object_id) {
        $.ajax(url, settings)
            .then(function (data, textStatus, jqXHR) {
            dispatch({
                type: action_type,
                payload: data,
                object_id: object_id,
            });
            success
                ? success(action_type, data, textStatus, jqXHR)
                : process_success(action_type, data, textStatus, jqXHR);
        })
            .fail(function (xhr, textStatus, errorThrown) {
            fail
                ? fail(action_type, xhr, textStatus, errorThrown)
                : process_failure(action_type, xhr, textStatus, errorThrown);
        });
    }
    function create(data) {
        var url = base_url;
        var request_data = JSON.stringify(data);
        var settings = get_settings(DataActionType.CREATE_PRE, request_data);
        make_request(url, settings, DataActionType.CREATE_POST);
    }
    function read(object_id) {
        var url = object_id
            ? (0, urls_1.trailing_slash)(base_url) + object_id + "/"
            : base_url;
        var settings = get_settings(DataActionType.READ_PRE);
        make_request(url, settings, DataActionType.READ_POST, object_id);
    }
    function update(data, object_id) {
        var url = object_id
            ? (0, urls_1.trailing_slash)(base_url) + object_id + "/"
            : base_url;
        var request_data = JSON.stringify(data);
        var settings = get_settings(DataActionType.UPDATE_PRE, request_data);
        make_request(url, settings, DataActionType.UPDATE_POST, object_id);
    }
    function remove(object_id) {
        var url = object_id
            ? (0, urls_1.trailing_slash)(base_url) + object_id + "/"
            : base_url;
        var settings = get_settings(DataActionType.DELETE_PRE);
        make_request(url, settings, DataActionType.DELETE_POST, object_id);
    }
    function list() {
        var url = base_url;
        var settings = get_settings(DataActionType.LIST_PRE);
        make_request(url, settings, DataActionType.LIST_POST);
    }
    function bulk_update(data) {
        var url = (0, urls_1.trailing_slash)(base_url) + "bulk-update/";
        var request_data = JSON.stringify(data);
        var settings = get_settings(DataActionType.BULK_UPDATE_PRE, request_data);
        make_request(url, settings, DataActionType.BULK_UPDATE_POST);
    }
    return {
        create: create,
        read: read,
        update: update,
        remove: remove,
        list: list,
        bulk_update: bulk_update,
        _make_request: make_request,
    };
}
exports.useRestData = useRestData;
